import {Component, OnDestroy, OnInit,NgZone} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectService} from '../project/project.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {Device, FORM_TYPE, MetaData} from '../models';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {mapKitForProject} from 'src/app/polar-SAAS-Components/api-helper'
// import * as moment from 'moment';
import {AuthService} from '../authentication/auth.service';
import {exitFullScreen, toggleModalById} from '../utils';
import * as moment from 'moment-timezone';

import * as XLSX from 'xlsx';

import * as QRCode from 'qrcode';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { EditDeviceService } from '../services/edit-device.service';
import { GoogleMapService } from '../google-map.service';
import { getAllKitTypes } from 'src/services/corporateService';
import authService from 'src/app/polar-SAAS-Components/auth-service'
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent implements OnInit, OnDestroy {
  form: FormGroup;
  projectId;
  devices: Device[];
  isSubmitted;
  formType;
  currentDeviceId;
  error;
  currentOptionMenu;

  FORM_TYPE;
  metaData: MetaData;

  intervalId;
  toggleTrue: boolean = false;

  data: JSON;
  noFileSelected = true;
  finalArray: Array<any> = [];
  files: File[] = [];
  currentName;

  selectedKits: number[] = [];
  isQRModalOpen = false;
  qrCodeUrl: string = '';
  isModalOpen: boolean = false;
  address = '';
  selectedAddress: string;
  predictions: any[];
  searchAddress:String;
  step:number=1;
  typeOfKits: any[] = [];
  isDeviceInputMethod: boolean = false;
  sensors:any[] = [
    {
      "code": "T",
      "codeValue": "Temperature"
    },
    {
      "code": "H",
      "codeValue": "Humidity"
    }]
   inputMethods=
        [
          { name: "Entry", value: 'MANUAL' ,isAllowed:true },
          { name: "Photo", value: 'IMAGE' ,isAllowed:authService.isAzurePlanSnapAllowed()},
          { name: "Device", value: 'DEVICE',isAllowed:false},
        ]
  isAzureUser = authService.isAzureUser();
  project: any;

  constructor(private route: ActivatedRoute, private toaster: ToastrService, private formBuilder: FormBuilder,
              private projectService: ProjectService, private spinner: NgxSpinnerService, protected router: Router,
            protected http: HttpClient,private editDeviceService: EditDeviceService,private googleMapsService: GoogleMapService){
    this.FORM_TYPE = FORM_TYPE;
  }

  async ngOnInit() {
    exitFullScreen();
    this.route.params.subscribe(params => {
      this.projectId = params['id'];
    });

    if (this.projectId === 'D_U') {
      this.getDevicesForDU();
      this.onLiveUpdateForDU();
    } else {
      this.getProject();
      this.getDevices();
      this.onLiveUpdate();
    }
        this.fetchAllKitTypes();

    this.form = this.formBuilder.group(
      {
        name: [null, Validators.compose([Validators.required])],
        description: [null, Validators.compose([])],
        status: [null, Validators.compose([])],
        deviceId: [null, Validators.compose([])],
        area: [null, Validators.compose([])],
        item: [null, Validators.compose([])],
        initialLocation: [null, Validators.compose( [] )],
        searchAddress: [null, Validators.compose([])],
        typeOfKit: [''],
        inputMethod:[''],
        brandModel: [''],
        storageCategory: [''],
        sensorsArray: this.formBuilder.array([
        this.formBuilder.group({ sensor: [''] })
      ])

       },  { validators: [this.AddressValidator(),this.customValidator()] }
        );
    await this.googleMapsService.load().subscribe(
      () => {
        console.log('Google Maps API loaded successfully');
      },
      (error) => {
        console.error('Error loading Google Maps API', error);
      }
    );
      if (authService.isAzureUser()) {
        // Add validators for Azure users
        this.form.get('typeOfKit').setValidators([Validators.required]);
        this.form.get('inputMethod').setValidators([Validators.required]);
        this.form.get('brandModel').setValidators([Validators.required]);
        this.form.get('storageCategory').setValidators([Validators.required]);

        // For sensorsArray
        const sensors = this.form.get('sensorsArray') as FormArray;
        sensors.controls.forEach((group: FormGroup) => {
        group.get('sensor').setValidators([Validators.required]);
        });
      };
    const isDatasaved = this.editDeviceService.isFormSaved();
    console.log('Is data saved:', isDatasaved); 
      if (isDatasaved) {
      const savedData = this.editDeviceService.getData();
      const deviceLocation=this.editDeviceService.getLocation();

      console.log('Saved data:', savedData,'location',deviceLocation);
      this.form.patchValue(savedData);
      
      this.form.controls.initialLocation.setValue({lat:deviceLocation.lat,lng:deviceLocation.lng});
      this.form.controls.searchAddress.setValue(deviceLocation.address);
      this.currentDeviceId = this.editDeviceService.getCurrentDeviceId();
      this.formType = this.editDeviceService.getFormType();
      this.toggleTrue = this.editDeviceService.getToggled();
      this.editDeviceService.setFormSaved(false);
       toggleModalById('addNew');
    }
  
    this.projectService.metaDataSource.subscribe(data => {
      this.metaData = data;
    });
  }
  ngAfterViewInit() {
    // this.spinner.hide();
    // this.getDevices(true);
    // this.getProject();
    // this.projectService.metaDataSource.subscribe(data => {
    //   this.metaData = data;
    // });
  }
  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  toggleQRModal() {
    this.isQRModalOpen = !this.isQRModalOpen;
    toggleModalById('qrPopup');
  }

  private normalizeDeviceId(device: any): string {
    const rawId = device && (device as any).id;
    if (typeof rawId === 'string') {
      return rawId;
    }
    if (rawId && typeof rawId === 'object') {
      return rawId.kitId || rawId.id || rawId.deviceId || '';
    }
    return rawId != null ? String(rawId) : '';
  }

  private buildQrPayload(device: Device): string {
    return JSON.stringify({ id: this.normalizeDeviceId(device) });
  }

  AddressValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const address = control.get('searchAddress').value;
      const initialLocation = control.get('initialLocation').value;
      console.log('address:', address, initialLocation, this.toggleTrue)
      if (address && address.length > 0 && initialLocation == null && this.toggleTrue) {
        control.setErrors({ invalidAddress: true });
        return { invalidAddress: true };
      }
      return null;
    };
  }
    customValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const deviceId = control.get('deviceId').value;
      console.log('deviceId:', deviceId, this.toggleTrue)
      if (deviceId && deviceId.length > 0 && this.form.get('inputMethod')!.value === 'DEVICE') {
        control.setErrors({ invalidDeviceId: true });
        return { invalidDeviceId: true };
      }
      return null;
    };
  }
  toggleSelection(index: number) {
    const selectedIndex = this.selectedKits.indexOf(index);
    if (selectedIndex === -1) {
      this.selectedKits.push(index);
    } else {
      this.selectedKits.splice(selectedIndex, 1);
    }
  }

  toggleSelectAll(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.selectedKits = this.devices.map((_, index) => index);
    } else {
      this.selectedKits = [];
    }
  }

  isAllSelected() {
    return this.selectedKits.length === this.devices.length;
  }

  async generateQR(device: Device) { 
    try {
        const data = this.buildQrPayload(device);
        const url = await QRCode.toDataURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.click();
        this.toaster.success('QR Code successfully generated!');
    } catch (error) {
        console.error('Error generating QR code:', error);
        this.toaster.error('Failed to generate QR Code');
    }
}


async downloadQR(device: Device) {
  try {
    const downloadUrl = await this.generateStyledQR(device);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `${device.name}-qr.png`;
    link.click();
  } catch (error) {
    console.error('Error generating styled QR code:', error);
  }
}


private async generateStyledQR(device: Device): Promise<string> {
const jsonData = this.buildQrPayload(device);
const qrDataUrl = await QRCode.toDataURL(jsonData);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d')!;
  const width = 400;
  const height = 600;
  canvas.width = width;
  canvas.height = height;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);

  const boxX = 30, boxY = 30, boxWidth = 340, boxHeight = 360, radius = 20;
  ctx.fillStyle = '#4a6b7c';
  ctx.beginPath();
  ctx.moveTo(boxX + radius, boxY);
  ctx.lineTo(boxX + boxWidth - radius, boxY);
  ctx.quadraticCurveTo(boxX + boxWidth, boxY, boxX + boxWidth, boxY + radius);
  ctx.lineTo(boxX + boxWidth, boxY + boxHeight - radius);
  ctx.quadraticCurveTo(boxX + boxWidth, boxY + boxHeight, boxX + boxWidth - radius, boxY + boxHeight);
  ctx.lineTo(boxX + radius, boxY + boxHeight);
  ctx.quadraticCurveTo(boxX, boxY + boxHeight, boxX, boxY + boxHeight - radius);
  ctx.lineTo(boxX, boxY + radius);
  ctx.quadraticCurveTo(boxX, boxY, boxX + radius, boxY);
  ctx.closePath();
  ctx.fill();

  const qrImage = new Image();
  qrImage.src = qrDataUrl;
  await new Promise(resolve => qrImage.onload = resolve);
  ctx.drawImage(qrImage, (width - 250) / 2, 50, 250, 250);

  const maximizeIcon = new Image();
  maximizeIcon.src = 'assets/images/maximize.svg';
  await new Promise(resolve => maximizeIcon.onload = resolve);
  const scanText = 'Scan Me!';
  ctx.font = 'bold 24px Arial';
  ctx.fillStyle = 'white';
  const iconSize = 24, textWidth = ctx.measureText(scanText).width;
  const totalWidth = iconSize + 10 + textWidth;
  const startX = (width - totalWidth) / 2;
  ctx.drawImage(maximizeIcon, startX, 330 - iconSize + 6, iconSize, iconSize);
  ctx.textAlign = 'left';
  ctx.fillText(scanText, startX + iconSize + 10, 330);

  ctx.font = '16px Arial';
  ctx.textAlign = 'center';
  ctx.fillText('Get instant access to device info', width / 2, 360);

  const alertIcon = new Image();
  alertIcon.src = 'assets/images/alert-circle.svg';
  await new Promise(resolve => alertIcon.onload = resolve);
  const alertText = 'Works best with POLAR Snapshot app';
  ctx.font = '14px Arial';
  const alertTextWidth = ctx.measureText(alertText).width;
  const alertIconSize = 18, alertPadding = 12, alertBoxHeight = 30;
  const alertBoxWidth = alertIconSize + 8 + alertTextWidth + alertPadding * 2;
  const alertBoxX = (width - alertBoxWidth) / 2;
  const alertBoxY = 405;
  const alertRadius = 10;

  ctx.fillStyle = '#F5F5F5';
  ctx.beginPath();
  ctx.moveTo(alertBoxX + alertRadius, alertBoxY);
  ctx.lineTo(alertBoxX + alertBoxWidth - alertRadius, alertBoxY);
  ctx.quadraticCurveTo(alertBoxX + alertBoxWidth, alertBoxY, alertBoxX + alertBoxWidth, alertBoxY + alertRadius);
  ctx.lineTo(alertBoxX + alertBoxWidth, alertBoxY + alertBoxHeight - alertRadius);
  ctx.quadraticCurveTo(alertBoxX + alertBoxWidth, alertBoxY + alertBoxHeight, alertBoxX + alertBoxWidth - alertRadius, alertBoxY + alertBoxHeight);
  ctx.lineTo(alertBoxX + alertRadius, alertBoxY + alertBoxHeight);
  ctx.quadraticCurveTo(alertBoxX, alertBoxY + alertBoxHeight, alertBoxX, alertBoxY + alertBoxHeight - alertRadius);
  ctx.lineTo(alertBoxX, alertBoxY + alertRadius);
  ctx.quadraticCurveTo(alertBoxX, alertBoxY, alertBoxX + alertRadius, alertBoxY);
  ctx.closePath();
  ctx.fill();

  const alertIconX = alertBoxX + alertPadding;
  ctx.drawImage(alertIcon, alertIconX, alertBoxY + 6, alertIconSize, alertIconSize);
  ctx.fillStyle = 'black';
  ctx.textAlign = 'left';
  ctx.fillText(alertText, alertIconX + alertIconSize + 8, alertBoxY + 20);

  const logoImage = new Image();
  logoImage.src = 'assets/images/polar.svg';
  await new Promise(resolve => logoImage.onload = resolve);
  const logoWidth = 120, logoHeight = 40;
  ctx.drawImage(logoImage, (width - logoWidth) / 2, 470, logoWidth, logoHeight);

  ctx.font = '14px Arial';
  ctx.fillStyle = 'black';
  ctx.textAlign = 'center';
  ctx.fillText('powered by SenzMate', width / 2, 470 + logoHeight + 20);

  return canvas.toDataURL('image/png');
}


  async downloadAllQR() {
    const zip = new JSZip();

    for (const device of this.devices) {
      try {
        const styledQRUrl = await this.generateStyledQR(device);

        const response = await fetch(styledQRUrl);
        const blob = await response.blob();

        zip.file(`${device.name}-qr.png`, blob);

      } catch (error) {
        console.error(`Error generating QR for ${device.name}:`, error);
      }
    }

    zip.generateAsync({ type: 'blob' }).then((zipBlob) => {
      saveAs(zipBlob, 'qr-codes.zip');
    });
  }


 async viewQR(device: Device) {
  try {
    console.log('View QR for device:', device);
    const jsonData = this.buildQrPayload(device);
    this.qrCodeUrl = await QRCode.toDataURL(jsonData);
    this.isModalOpen = true;
  } catch (error) {
    console.error('Error generating QR code:', error);
  }
}

  closeModal() {
    this.isModalOpen = false;
  }
  
  downloadImage(url: string, filename: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
  }
  async onAddressChange(event:any): Promise<void> {
    this.address=event.target.value;
    this.form.controls.initialLocation.setValue(null);
    if (this.address.length < 3) {
      this.predictions = [];
      return;
    }
    this.googleMapsService.getGooglePlaceAutoCompleteList(this.address).then((predictions) => {
      this.predictions = predictions;
    });

    console.log('pred',this.predictions)
  }

  fetchLatLonbByPlaceId(placeId: string): void {
    this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeId}&key=${environment.googleMapKey}`)
      .subscribe((response: any) => {
        console.log('Place details:', response);
        if (response.status === 'OK') {
          const location = response.results[0].geometry.location;
          this.form.controls.initialLocation.setValue(location);
        }
      });

  }



  selectAddress(selectedAddress: any): void {
    this.selectedAddress = selectedAddress;
    this.form.controls.searchAddress.setValue( selectedAddress.description);
    this.fetchLatLonbByPlaceId(selectedAddress.place_id);
           
    this.predictions = [];
  }
  navigateToLocation() {
    // Save form data before navigating
    this.editDeviceService.saveData(this.form.value);
    this.editDeviceService.setFormSaved(true);
    this.editDeviceService.saveCurrentDeviceId(this.currentDeviceId);
    this.editDeviceService.setToggled(this.toggleTrue)
    this.editDeviceService.setFormType(this.formType);
    console.log('Navigating to location:', this.projectId, this.currentDeviceId,this.form.value);
    this.router.navigate(['/initial-location',this.projectId,this.currentDeviceId]);
  }
  getProject() {
    this.spinner.show();
    this.projectService.getProject(this.projectId)
      .subscribe(response => {
         this.project = response.content;
        this.projectService.projectNameSource.next(response.content.name);
      }, error => {
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      });
  }

  getDevices(isSilence = false) {
    if (!isSilence) {
      this.spinner.show();
    }

    this.projectService.getDevicesOfProject(this.projectId)
      .subscribe(response => {
        this.devices = response.content;
      }, error => {
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      });
  }


  getDevicesForDU(isSilence = false) {
    if (!isSilence) {
      this.spinner.show();
    }

    this.projectService.getKitsForKitUsers()
      .subscribe(response => {
        this.devices = response.content;
        // this.projectService.deviceNameSource.next(this.device.name);

        // this.getAlertLimitForProperty();

        // this.loadGraph();
      }, error => {
        this.spinner.hide();
      }, () => {
        this.spinner.hide();
      });
  }

  onLiveUpdate() {
    this.intervalId = setInterval(() => {
      this.getDevices(true);
    }, 1000 * 60);
  }

  onLiveUpdateForDU() {
    this.intervalId = setInterval(() => {
      this.getDevicesForDU(true);
    }, 1000 * 60);
  }

  buildSensorMap(sensorArray: FormArray): Record<string, string> {
    const map: Record<string, string> = {};
    console.log('building sensor map inside', sensorArray);
    sensorArray.controls.forEach((s, idx) => {
      console.log('sensor control', s);
      const sensorCode = s.value.sensor;
      console.log('code added', sensorCode);
      if (sensorCode) {
        map[idx] = sensorCode;
      }
    });
    return map;
  }
  async createDevice(entity) {
    this.isSubmitted = true;
    this.error = null;
    console.log('create device called')
    this.form.updateValueAndValidity();
    if (!this.form.valid) {
      console.log('Form is invalid');
      return;
    }
     if (this.toggleTrue) {
      entity.metaData = {area: entity.searchAddress, item: entity.item };
    } else {
      delete entity.initialLocation
    }
    delete entity.searchAddress;
    delete entity.area;
    this.spinner.show();
    entity.id = entity.deviceId;
    console.log('form',this.form.value,entity)
    if (this.formType === FORM_TYPE.ADD) {

      if(this.isAzureUser&&this.form.get('inputMethod').value !== 'DEVICE') {
        console.log('sensor map for  called')
        const sensorArray = this.form.get('sensorsArray') as FormArray;
        console.log('sensor map for  called',sensorArray)
        entity.sensorMap = this.buildSensorMap(sensorArray);
        delete entity.sensorsArray;
        delete entity.id;
        delete entity.deviceId;
        delete entity.status;
        delete entity.item;
        entity.projectId = this.projectId;

        try{
        const response=await mapKitForProject(entity)
        this.spinner.hide();
        toggleModalById('addNew');
        this.toaster.success('Device updated successfully', 'Success');
        this.getDevices();
        this.step=1;
        console.log("New kit created:", response);
        }
        catch(error){
          this.spinner.hide();
          if (error.status === 422) {
            this.error = error.error.message;
          } else {
            this.toaster.error('Oops... Something went wrong', 'Error!');
          }
          
        }

      } else {
        delete entity.sensorsArray;
        delete entity.typeOfKit;
        delete entity.inputMethod;
        delete entity.brandModel;
        delete entity.storageCategory;
        delete entity.item;
        delete entity.status;
        this.projectService.createDevice(this.projectId, entity).subscribe(response => {
          this.spinner.hide();
          toggleModalById('addNew');
          this.getDevices();
          // this.devices.push(entity);
        this.toaster.success('Device Created successfully', 'Success');
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });}
    } else {
        delete entity.sensorsArray;
        delete entity.typeOfKit;
        delete entity.inputMethod;
        delete entity.brandModel;
        delete entity.storageCategory;
      this.projectService.updateDevice(this.projectId, this.currentDeviceId, entity).subscribe(response => {
        this.spinner.hide();
        toggleModalById('addNew');
        this.getDevices();
        this.toaster.success('Device updated successfully', 'Success');
        this.getDevices();
      }, error => {
        this.spinner.hide();
        if (error.status === 422) {
          this.error = error.error.message;
        } else {
          this.toaster.error('Oops... Something went wrong', 'Error!');
        }
      });
    }
  }

  isDeviceOnline(time, interval) {
    // if (!time) {
    //   return false;
    // }
    // const ist = moment.tz(time, 'Asia/Colombo');
    // const ut = ist.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    // return moment().diff(ut) / (1000 * 60) <= interval;

    if (!time || !interval) {
      return false;
    }

    // console.log(time);
    interval = interval * 3;

    const today = new Date();
    // console.log(today)
    const ist = moment.tz(time, 'Asia/Colombo');
    // console.log(ist)
    const ut = ist.clone().tz(Intl.DateTimeFormat().resolvedOptions().timeZone);
    // console.log(ut)
    // @ts-ignore
    const diffMs = (today - ut);
    // console.log(diffMs)
    const diffMinutes = Math.round(diffMs / 60000);
    // console.log(diffMinutes)
    return diffMinutes <= interval;
  }

  toBrowserTimeZone(value) {

    const timeZone = moment.tz.guess();
    // console.log("timeZone: ",timeZone)

    const ist = moment.tz(value, 'Asia/Colombo');
    // console.log("ist: ",ist)

    ist.tz(timeZone);
    // console.log("ist: ",ist)
    // console.log("toBrowserTimeZone: ",ist.format('YYYY-MM-DD HH:mm:ss'))

    return ist.format('YYYY-MM-DD HH:mm:ss');
  }

  getBatteryLevel(level) {
    if (level >= 100) {
      return 'fa-battery-full';
    } else if (level > 75) {
      return 'fa-battery-three-quarters';
    } else if (level > 50) {
      return 'fa-battery-half';
    } else if (level > 25) {
      return 'fa-battery-quarter';
    } else if (level > 0) {
      return 'fa-battery-empty';
    } else {
      return 'fa-bolt';
    }
  }

  getText(level) {
    if (level > 0) {
      return level + '%';
    } else {
      return 'Charging';
    }
  }

  addDeviceInit() {
    this.isSubmitted = false;
    this.formType = FORM_TYPE.ADD;
    this.form.reset();
    this.error = null;
  }

  editDevice(device) {
    this.currentDeviceId = device.id;
    this.formType = FORM_TYPE.EDIT;
    this.form.controls.name.setValue(device.name);
    this.form.controls.description.setValue(device.description);
    this.form.controls.status.setValue(device.status);
    this.form.controls.deviceId.setValue('A');
    this.form.controls.area.setValue(device.metaData ? device.metaData.area : '');
    this.form.controls.item.setValue(device.metaData ? device.metaData.item : '');
    this.form.controls.searchAddress.setValue( device.metaData.area ? device.metaData.area : '');
    this.form.controls.initialLocation.setValue({ lat: device.initialLocation.lat, lng: device.initialLocation.lng });
  }

  optionMenu(project) {
    this.currentOptionMenu = project;
  }

  outsideOptionMenu(project) {
    if (this.currentOptionMenu && project.id === this.currentOptionMenu.id) {
      this.currentOptionMenu = null;
    }
  }

  deleteProject() {
    this.spinner.show();
    this.projectService.deleteDevice(this.projectId, this.currentDeviceId).subscribe(response => {
      toggleModalById('deleteUser');
      this.spinner.hide();
      this.getDevices();
      this.toaster.success('Successfully deleted', 'Success');
    }, error => {
      this.spinner.hide();
      this.toaster.error('Oops... Something went wrong', 'Error!');
    });
  }

  isSuperAdmin() {
    return AuthService.isSuperAdmin();
  }
  isCorporateSAASAdmin() {
    return AuthService.isCorporateSAASAdmin();
  }


  goToUserManagement(projectId, deviceId) {
    this.router.navigate(['/device-user', projectId, deviceId]);
  }

  changeButton() {
    if (this.toggleTrue) {
      this.toggleTrue = false;
    } else {
      this.toggleTrue = true;
    }

    console.log('Initial Values ');
  }

  toggleUpload() {
    toggleModalById('upload data');
  }

  idFinder(device) {
    this.currentDeviceId = device.id;
    this.currentName = device.name;
  }

  onFileChange(event) {
    if (this.files && this.files.length >= 1) {
      this.onRemove(this.files[0]);
      this.noFileSelected = false;
    }
    this.files.push(...event.addedFiles);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();

    if (this.files.length == 1) {
      const file = this.files[0];
      reader.onload = event => {
        this.finalArray = [];
        const data = reader.result;
        workBook = XLSX.read(data, {type: 'binary'});
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet, {range: 11, header: ['Date', 'Time', 'Temperature'], dateNF: 'dd"."mm"."yyyy'});
          return initial;
        }, {});

        const dataString = JSON.stringify(jsonData.Sheet1);
        this.data = jsonData.Sheet1;

        this.noFileSelected = false;

        for (let i = 0; i < Object.keys(this.data).length - 1; i++) {

          const date_arr = this.data[i].Date.split('/', 3);

          const formatted_date = date_arr[2] + '-' + date_arr[1] + '-' + date_arr[0].substring(1);

          const datetime = formatted_date + ' ' + this.data[i].Time;

          this.finalArray.push(
            {
              'alert': true,
              'code': 'T',
              'error': true,
              'kitId': this.currentDeviceId,
              'number': 0,
              'value': this.data[i].Temperature,
              'time': datetime
            }
          );
        }

      };
      reader.readAsBinaryString(file);

    }
    if (this.files.length == 0) {
      this.noFileSelected = true;
    }

  };

  send_data() {
    this.spinner.show();
    this.toggle();
    this.projectService.createProperties(this.currentDeviceId, this.finalArray).subscribe(response => {
      this.spinner.hide();
      this.toaster.success('Uploaded Successfully', 'Success');
      this.noFileSelected = true;
      this.reset();
      this.toggleUpload();
      this.getDevices();

    }, error => {
      this.spinner.hide();

      if (error && error.status === 422) {
        error = error.error.message;
        this.toaster.error(error);

      } else {
        this.toaster.error('Oops.. Something went wrong ');

      }
    });
  }

  reset() {
    this.files = [];
    this.finalArray = [];
    this.noFileSelected = true;
  }

  toggle() {
    toggleModalById('upload');
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  hasEntityManagementAccess(){
    return AuthService.hasEntityManagementAccess();
  }

  hasDevices(): boolean {
    return this.devices && this.devices.length > 0;
  }


  nextStep() {
    if (this.step < 2) { // adjust max step
      this.step++;
    }
  }

  prevStep() {
    if (this.step > 1) {
      this.step--;
    }
  }
  
  get sensorsArray() {
    return this.form.get('sensorsArray') as FormArray;
  }
  // Add sensor dynamically
  addSensor() {
    this.sensorsArray.push(this.formBuilder.group({ sensor: ['', Validators.required] }));
  }

  // Remove sensor
  removeSensor(i: number) {
    this.sensorsArray.removeAt(i);
  }
  // --- FETCH KIT TYPES ---
  async fetchAllKitTypes() {
    console.log('getting kit types');
    try {
      const response: any = await getAllKitTypes()
      console.log('types', response.content);

      const allowedTypes = ['TRUCK', 'COLD_ROOM', 'FREEZER'];
      this.typeOfKits = response.content.filter((type: { name: string }) =>
        allowedTypes.includes(type.name)
      );

      console.log('kitTypes', this.typeOfKits);
    } catch (err) {
      console.error('Error fetching kit types', err);
    }
  }


}
